import { render } from "./ReportCenter.vue?vue&type=template&id=7e7afbf8"
import script from "./ReportCenter.vue?vue&type=script&lang=js"
export * from "./ReportCenter.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__